import { useCallback, useEffect, useState } from 'react'
import classNames from 'classnames'

import { Button } from 'components/ui/Button/Button'
import TitledContainer from 'components/ui/TitledContainer/TitledContainer'
import { WarehouseSearch } from 'components/WarehouseSearch/WarehouseSearch'
import { Warehouse, WarehouseType } from 'services/warehouse-containers/warehouse'
import { ReactComponent as Arrow } from 'images/arrow-up.svg'

import './direction.style.css'

const WAREHOUSE_TYPES = [
  WarehouseType.MiniWarehouse,
  WarehouseType.MobileWarehouse,
  WarehouseType.Courier,
]

export type Props = {
  title?: string
  hint?: string
  fromWarehouse: Pick<Warehouse, 'id' | 'name'>
  toWarehouse: Pick<Warehouse, 'id' | 'name'>
  onSearch: (fromWarehouse: Warehouse, toWarehouse: Warehouse) => void
}

// TODO: После нажатия на Search кнопку, нужно опустить скрол до нижней границы блока
// или придумать другой блок, которые будет виден только когда выйти сколом за границы
// основного блока.

export const MovementDirection = ({
  title = 'Перемещение',
  hint = 'Поиск контейнеров осуществляется после указания направления перемещения...',
  fromWarehouse = { id: 0, name: '' },
  toWarehouse = { id: 0, name: '' },
  onSearch,
}: Props) => {
  const [isToogle, setIsToogle] = useState<boolean>(true)
  const [from, setFrom] = useState<Warehouse>(null)
  const [to, setTo] = useState<Warehouse>(null)

  useEffect(() => {
    setIsToogle(!fromWarehouse.id || !toWarehouse.id)
  }, [fromWarehouse, toWarehouse])

  const renderDirectionPlaceholder = useCallback(() => {
    let fromPlaceholder = 'Неизвестно'
    let toPlaceholder = fromPlaceholder

    if (Boolean(fromWarehouse.id) && Boolean(toWarehouse.id)) {
      fromPlaceholder = fromWarehouse.name
      toPlaceholder = toWarehouse.name
    }

    const handleOnClick = () => {
      setIsToogle((prev) => !prev)
    }

    const classnameDirection = classNames('direction-short__direction', {
      'direction-short__direction-inactive': !fromWarehouse.id || !toWarehouse.id,
    })

    const classnameArrow = classNames('direction-short__arrow', {
      disable: !fromWarehouse.id || !toWarehouse.id,
      rotate: isToogle,
    })

    return (
      <div className="direction-short">
        <Arrow onClick={handleOnClick} className={classnameArrow} />
        <span>Текущее направление:</span>
        <span className={classnameDirection}>
          {fromPlaceholder} &#8594; {toPlaceholder}
        </span>
      </div>
    )
  }, [fromWarehouse, toWarehouse, isToogle])

  const handleOnSelectFrom = (warehouse: Warehouse) => setFrom(warehouse)
  const handleOnSelectTo = (warehouse: Warehouse) => setTo(warehouse)

  const handleOnSubmit = () => {
    if (!from || !to) return

    onSearch?.(from, to)
    setIsToogle(false)
  }

  const classname = classNames('direction__accordion-body', {
    open: isToogle,
  })

  return (
    <TitledContainer title={title} hint={hint}>
      {renderDirectionPlaceholder()}
      <div className={classname}>
        <form className="transfer-page-search">
          <span className="transfer-page-search__header">Откуда:</span>
          <WarehouseSearch onSelect={handleOnSelectFrom} searchForTypes={WAREHOUSE_TYPES} />
          <span className="transfer-page-search__header">Куда:</span>
          <WarehouseSearch onSelect={handleOnSelectTo} searchForTypes={WAREHOUSE_TYPES} />
        </form>
        <Button disabled={!from || !to} title="Найти" handleOnSubmit={handleOnSubmit}></Button>
      </div>
    </TitledContainer>
  )
}
